module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-white"
  }, [_c('el-row', {
    staticClass: "content-bottom-padded",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addResource
    }
  }, [_vm._v("添加权益")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.rightsList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.label_infos), function(info) {
          return _c('div', [_c('span', [_vm._v("包含物料：")]), _c('el-tag', {
            attrs: {
              "type": "success"
            }
          }, [_vm._v(_vm._s(info.label_name))])], 1)
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rights_name",
      "label": "名称",
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rights_from",
      "label": "来源",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operator_desc",
      "label": "代客下单操作员"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_num",
      "label": "总数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.is_not_limit_num == 2) ? _c('span', [_vm._v(_vm._s(scope.row.total_num))]) : _vm._e(), _vm._v(" "), (scope.row.is_not_limit_num == 1) ? _c('span', [_vm._v("无限次")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_consum_num",
      "label": "已核销数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "过期时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.end_time)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.is_not_limit_num == 2) ? [(scope.row.total_num == scope.row.total_consum_num) ? _c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("已用完")]) : _vm._e()] : _vm._e(), _vm._v(" "), (scope.row.is_not_limit_num == 1) ? [_c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("无限次")])] : (scope.row.is_valid == '1') ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v("有效")]) : _c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("已过期")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-padded tc"
  }, [_c('el-pagination', {
    attrs: {
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "right-dialog",
    attrs: {
      "title": "添加权益",
      "visible": _vm.addRightsDialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.addRightsDialog = $event
      }
    }
  }, [
    [_c('el-form', [_c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "选择权益商品"
      }
    }, [_c('el-transfer', {
      attrs: {
        "titles": ['商品列表', '已选中'],
        "data": _vm.goodsList
      },
      model: {
        value: (_vm.addRightsItems),
        callback: function($$v) {
          _vm.addRightsItems = $$v
        },
        expression: "addRightsItems"
      }
    }, [_c('div', {
      staticClass: "transfer-footer",
      attrs: {
        "slot": "left-footer"
      },
      slot: "left-footer"
    }, [(_vm.goods_total_count > _vm.goodsParams.pageSize) ? _c('el-pagination', {
      attrs: {
        "small": "",
        "layout": "prev, pager, next",
        "total": _vm.goods_total_count,
        "page-size": _vm.goodsParams.pageSize
      },
      on: {
        "current-change": _vm.handleGoodsChange
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "transfer-footer",
      attrs: {
        "slot": "right-footer"
      },
      slot: "right-footer"
    })])], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.onSubmit
      }
    }, [_vm._v("确定添加")])], 1)], 1)]
  ], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-70c7ac67", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70c7ac67"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/members/quanyilist.vue
// module id = 2817
// module chunks = 0